import "../styles/Login.css"
import { FaDownload, FaCog } from "react-icons/fa"
import { Link } from "react-router-dom"
import Logo from "../components/Logo"
import backgroundVideo from "../assets/hero-background.mp4"

function Register() {
    return (
        <div className="login-container gradient-background">
            <video autoPlay loop muted playsInline className="login-background-video">
                <source src={backgroundVideo} type="video/mp4" />
            </video>
            <div className="login-overlay"></div>
            
            <header className="login-header-nav">
                <Logo size="small" showText={false} linkTo="/" />
                <nav className="nav-links">
                    <Link to="/downloads" className="download-nav-link"><FaDownload /> Download</Link>
                    <Link to="/login" className="login-link">Login</Link>
                </nav>
            </header>
            
            <div className="login-content">
                <div className="login-card" style={{ textAlign: "center", padding: "2.5rem 2rem" }}>
                    <div style={{ marginBottom: "1.5rem" }}>
                        <FaCog style={{ fontSize: "2.5rem", color: "#a78bfa", animation: "spin 4s linear infinite" }} />
                    </div>
                    <div className="login-header" style={{ marginBottom: "1rem" }}>
                        <h2>We're Upgrading</h2>
                        <p style={{ lineHeight: 1.7 }}>
                            New registrations are temporarily paused while<br />
                            we improve the platform. Check back soon!
                        </p>
                    </div>
                    <p style={{ fontSize: "0.85rem", color: "#64748b", marginTop: "1.5rem" }}>
                        Questions? <a href="mailto:support@triagz.com" style={{ color: "#7c8cf8" }}>support@triagz.com</a>
                    </p>
                    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                </div>
            </div>
        </div>
    )
}

export default Register